import React from 'react';
import ReactModal from 'react-modal';
import { ThemeProvider } from 'styled-components';
import { RouterProvider } from 'react-router-dom';
import router from './app/route';
import { appThemeConfig } from './themeConfig';

function App() {
  ReactModal.setAppElement('body');
  return (
    <ThemeProvider theme={appThemeConfig.light}>
      <RouterProvider router={router} />
    </ThemeProvider>
  );
}

export default App;
